module.exports = __webpack_public_path__ + "fa-light-300.128ba6b5a380ea45e4a2.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-light-300.woff2
// module id = ../../../../../src/assets/fonts/webfonts/fa-light-300.woff2
// module chunks = styles